import Collapse from 'bootstrap/js/dist/collapse';
import './site-search-desktop.scss';
import { AnalyticsService } from '../../../typescript/common/analytics-service';

(function siteSearchDesktop() {
  // Get a reference to the search desktop component
  const searchElement: HTMLElement | null = document.querySelector('[data-component="site-search-desktop-component"]');
  if (!searchElement) return;

  // Get a reference to the arrow icon element shown search menu item when the search is open
  const menuArrowIconElement: HTMLElement | null = document.querySelector('[data-component="secondary-menu-desktop-search-menu-arrow"]');

  // Get a reference to the login desktop component
  const loginElement: HTMLElement | null = document.querySelector('[data-component="login-desktop-component"]');

  // Hide the search component when the login component is shown
  if (loginElement) {
    loginElement.addEventListener('show.bs.collapse', () => {
      Collapse.getInstance(searchElement)?.hide();
    });
  }

  // Show the arrow icon when the search component is shown
  searchElement.addEventListener('show.bs.collapse', () => {
    menuArrowIconElement?.classList.remove('d-none');
  });
  searchElement.addEventListener('hide.bs.collapse', () => {
    menuArrowIconElement?.classList.add('d-none');
  });

  // Add tracking
  (document.querySelectorAll('[data-component="desktop-login-button"]') as NodeListOf<HTMLElement>).forEach((loginButton) => {
    loginButton.addEventListener('click', () => {
      AnalyticsService.addEvent(AnalyticsService.HeaderCategory, 'Öppna/stäng inloggningsval', loginButton.innerText?.trim());
    });
  });
})();
